

const AvailabilityLandingView = () =>
  import(
    /*webpackChunkName: "AvailabilityLandingView"*/ "../../../views/sales/AvailabilityLanding.vue"
  );
export default {
  path: "lp/entertainment-in-spanish",
  name: "available-on",
  alias: ["lp/entretenimiento-en-espanol"],
  component: AvailabilityLandingView,
  meta: { requiresAuth: false, requiresEntitlement: false },
};
